import React from 'react';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { APPLICATIONS_ONE_FRONT_DOOR_URL, BENEFITS_URL } from 'src/utilities/envConfig';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { useDecision } from '@optimizely/react-sdk';
import { ONE_FRONT_DOOR } from '@src/constants/featureFlags';
import styles from './NoResultsDropdown.module.scss';

export const NoResultsDropdown = () => {
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const [oneFrontDoorDecision] = useDecision(ONE_FRONT_DOOR);

	const OneFrontDoorEnabledFooter = () => (
		<Typography variant='body1'>
			If you&apos;re looking for a specific program,{' '}
			<TextLink
				data-testid='one-front-door-link'
				href={APPLICATIONS_ONE_FRONT_DOOR_URL}
				variant='standalone'
			>
				check if {user?.employer || 'your employer'} covers it.
			</TextLink>
		</Typography>
	);

	const BenefitsFooter = () => (
		<Typography variant='body1'>
			Or explore your{' '}
			<TextLink data-testid='benefit-options' href={BENEFITS_URL} target='_blank'>
				benefit options
			</TextLink>
		</Typography>
	);

	return (
		<div className={styles.noResultsContainer} data-testid='no-results-dropdown'>
			<Typography className={styles.noResultsHeader} role='alert' variant='h2'>
				We can&apos;t find any programs that match your search
			</Typography>
			<ul className={styles.noResultsList}>
				<Typography variant='body1'>
					<li>Double check your spelling</li>
				</Typography>
				<Typography variant='body1'>
					<li>Use fewer key words</li>
				</Typography>
			</ul>
			{oneFrontDoorDecision?.enabled ? <OneFrontDoorEnabledFooter /> : <BenefitsFooter />}
		</div>
	);
};
